/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./pages/__root";
import { Route as TestingRouteRouteImport } from "./pages/testing/route";
import { Route as SettingsRouteRouteImport } from "./pages/settings/route";
import { Route as RecordDetailsRouteRouteImport } from "./pages/record-details/route";
import { Route as PrpScriptRouteRouteImport } from "./pages/prp-script/route";
import { Route as ProfileRouteRouteImport } from "./pages/profile/route";
import { Route as PerformanceRouteRouteImport } from "./pages/performance/route";
import { Route as ManagementRouteRouteImport } from "./pages/management/route";
import { Route as ListsRouteRouteImport } from "./pages/lists/route";
import { Route as IncidentsRouteRouteImport } from "./pages/incidents/route";
import { Route as EventsRouteRouteImport } from "./pages/events/route";
import { Route as CallsRouteRouteImport } from "./pages/calls/route";
import { Route as CalendarsRouteRouteImport } from "./pages/calendars/route";
import { Route as CalendarRouteRouteImport } from "./pages/calendar/route";
import { Route as BlogRouteRouteImport } from "./pages/blog/route";
import { Route as AiRouteRouteImport } from "./pages/ai/route";
import { Route as IndexRouteImport } from "./pages/index";
import { Route as TestingIndexRouteImport } from "./pages/testing/index";
import { Route as SettingsIndexRouteImport } from "./pages/settings/index";
import { Route as PrpScriptIndexRouteImport } from "./pages/prp-script/index";
import { Route as ProfileIndexRouteImport } from "./pages/profile/index";
import { Route as ListsIndexRouteImport } from "./pages/lists/index";
import { Route as IncidentsIndexRouteImport } from "./pages/incidents/index";
import { Route as HotelCapacityIndexRouteImport } from "./pages/hotel-capacity/index";
import { Route as HelpCenterIndexRouteImport } from "./pages/help-center/index";
import { Route as EventsIndexRouteImport } from "./pages/events/index";
import { Route as CallsIndexRouteImport } from "./pages/calls/index";
import { Route as CalendarsIndexRouteImport } from "./pages/calendars/index";
import { Route as AppointmentsIndexRouteImport } from "./pages/appointments/index";
import { Route as PerformanceReportsRouteImport } from "./pages/performance/reports";
import { Route as PerformanceKpisRouteImport } from "./pages/performance/kpis";
import { Route as PerformanceCalendarCapacitiesRouteImport } from "./pages/performance/calendar-capacities";
import { Route as CustomPageSlugRouteImport } from "./pages/custom-page/$slug";
import { Route as BlogIdRouteImport } from "./pages/blog/$id";
import { Route as AiDimensionsRouteImport } from "./pages/ai/dimensions";
import { Route as AiDimensionDefinitionsRouteImport } from "./pages/ai/dimension-definitions";
import { Route as PerformanceSettingPriorityReportRouteRouteImport } from "./pages/performance/setting-priority-report/route";
import { Route as PerformanceQualityWatchRouteRouteImport } from "./pages/performance/quality-watch/route";
import { Route as PerformanceCallVolumeRouteRouteImport } from "./pages/performance/call-volume/route";
import { Route as ManagementSchedulesRouteRouteImport } from "./pages/management/schedules/route";
import { Route as EventsIdRouteRouteImport } from "./pages/events/$id/route";
import { Route as TestingKpisReportIndexRouteImport } from "./pages/testing/kpis-report/index";
import { Route as TestingIncidentAnalyticsIndexRouteImport } from "./pages/testing/incident-analytics/index";
import { Route as PerformanceSettingPriorityReportIndexRouteImport } from "./pages/performance/setting-priority-report/index";
import { Route as PerformanceReachabilityAnalysisIndexRouteImport } from "./pages/performance/reachability-analysis/index";
import { Route as PerformanceQualityWatchIndexRouteImport } from "./pages/performance/quality-watch/index";
import { Route as PerformanceCallVolumeIndexRouteImport } from "./pages/performance/call-volume/index";
import { Route as PerformanceCallExportsIndexRouteImport } from "./pages/performance/call-exports/index";
import { Route as PerformanceAppointmentAnalyticsIndexRouteImport } from "./pages/performance/appointment-analytics/index";
import { Route as PerformanceAgentQualityMatrixIndexRouteImport } from "./pages/performance/agent-quality-matrix/index";
import { Route as ManagementUsersIndexRouteImport } from "./pages/management/users/index";
import { Route as ManagementTeamsIndexRouteImport } from "./pages/management/teams/index";
import { Route as ManagementSchedulesIndexRouteImport } from "./pages/management/schedules/index";
import { Route as ManagementPhoneNumbersIndexRouteImport } from "./pages/management/phone-numbers/index";
import { Route as ManagementCustomPagesIndexRouteImport } from "./pages/management/custom-pages/index";
import { Route as CallsCallIdIndexRouteImport } from "./pages/calls/$callId/index";
import { Route as CalendarsIdIndexRouteImport } from "./pages/calendars/$id/index";
import { Route as CalendarAppointmentsIndexRouteImport } from "./pages/calendar/appointments/index";
import { Route as SettingsIntegrationsSlackRedirectRouteImport } from "./pages/settings/integrations/slack-redirect";
import { Route as RecordDetailsRecordIdModuleTypeRouteImport } from "./pages/record-details/$recordId.$moduleType";
import { Route as EventsIdSlotsRouteRouteImport } from "./pages/events/$id/slots/route";
import { Route as EventsIdRulesRouteRouteImport } from "./pages/events/$id/rules/route";
import { Route as EventsIdBookingsRouteRouteImport } from "./pages/events/$id/bookings/route";
import { Route as ManagementSchedulesManageIndexRouteImport } from "./pages/management/schedules/manage/index";
import { Route as EventsIdSlotsIndexRouteImport } from "./pages/events/$id/slots/index";
import { Route as EventsIdRulesIndexRouteImport } from "./pages/events/$id/rules/index";
import { Route as EventsIdBookingsIndexRouteImport } from "./pages/events/$id/bookings/index";
import { Route as EventsIdRulesPlanIdRouteImport } from "./pages/events/$id/rules/$planId";
import { Route as PerformanceSettingPriorityReportSettingPriorityLeadsLanguagePriorityRouteImport } from "./pages/performance/setting-priority-report/setting-priority-leads/$language.$priority";

const TestingRouteRoute = TestingRouteRouteImport.update({
  id: "/testing",
  path: "/testing",
  getParentRoute: () => rootRouteImport,
} as any);
const SettingsRouteRoute = SettingsRouteRouteImport.update({
  id: "/settings",
  path: "/settings",
  getParentRoute: () => rootRouteImport,
} as any);
const RecordDetailsRouteRoute = RecordDetailsRouteRouteImport.update({
  id: "/record-details",
  path: "/record-details",
  getParentRoute: () => rootRouteImport,
} as any);
const PrpScriptRouteRoute = PrpScriptRouteRouteImport.update({
  id: "/prp-script",
  path: "/prp-script",
  getParentRoute: () => rootRouteImport,
} as any);
const ProfileRouteRoute = ProfileRouteRouteImport.update({
  id: "/profile",
  path: "/profile",
  getParentRoute: () => rootRouteImport,
} as any);
const PerformanceRouteRoute = PerformanceRouteRouteImport.update({
  id: "/performance",
  path: "/performance",
  getParentRoute: () => rootRouteImport,
} as any);
const ManagementRouteRoute = ManagementRouteRouteImport.update({
  id: "/management",
  path: "/management",
  getParentRoute: () => rootRouteImport,
} as any);
const ListsRouteRoute = ListsRouteRouteImport.update({
  id: "/lists",
  path: "/lists",
  getParentRoute: () => rootRouteImport,
} as any);
const IncidentsRouteRoute = IncidentsRouteRouteImport.update({
  id: "/incidents",
  path: "/incidents",
  getParentRoute: () => rootRouteImport,
} as any);
const EventsRouteRoute = EventsRouteRouteImport.update({
  id: "/events",
  path: "/events",
  getParentRoute: () => rootRouteImport,
} as any);
const CallsRouteRoute = CallsRouteRouteImport.update({
  id: "/calls",
  path: "/calls",
  getParentRoute: () => rootRouteImport,
} as any);
const CalendarsRouteRoute = CalendarsRouteRouteImport.update({
  id: "/calendars",
  path: "/calendars",
  getParentRoute: () => rootRouteImport,
} as any);
const CalendarRouteRoute = CalendarRouteRouteImport.update({
  id: "/calendar",
  path: "/calendar",
  getParentRoute: () => rootRouteImport,
} as any);
const BlogRouteRoute = BlogRouteRouteImport.update({
  id: "/blog",
  path: "/blog",
  getParentRoute: () => rootRouteImport,
} as any);
const AiRouteRoute = AiRouteRouteImport.update({
  id: "/ai",
  path: "/ai",
  getParentRoute: () => rootRouteImport,
} as any);
const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any);
const TestingIndexRoute = TestingIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => TestingRouteRoute,
} as any);
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => SettingsRouteRoute,
} as any);
const PrpScriptIndexRoute = PrpScriptIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => PrpScriptRouteRoute,
} as any);
const ProfileIndexRoute = ProfileIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => ProfileRouteRoute,
} as any);
const ListsIndexRoute = ListsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => ListsRouteRoute,
} as any);
const IncidentsIndexRoute = IncidentsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => IncidentsRouteRoute,
} as any);
const HotelCapacityIndexRoute = HotelCapacityIndexRouteImport.update({
  id: "/hotel-capacity/",
  path: "/hotel-capacity/",
  getParentRoute: () => rootRouteImport,
} as any);
const HelpCenterIndexRoute = HelpCenterIndexRouteImport.update({
  id: "/help-center/",
  path: "/help-center/",
  getParentRoute: () => rootRouteImport,
} as any);
const EventsIndexRoute = EventsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => EventsRouteRoute,
} as any);
const CallsIndexRoute = CallsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => CallsRouteRoute,
} as any);
const CalendarsIndexRoute = CalendarsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => CalendarsRouteRoute,
} as any);
const AppointmentsIndexRoute = AppointmentsIndexRouteImport.update({
  id: "/appointments/",
  path: "/appointments/",
  getParentRoute: () => rootRouteImport,
} as any);
const PerformanceReportsRoute = PerformanceReportsRouteImport.update({
  id: "/reports",
  path: "/reports",
  getParentRoute: () => PerformanceRouteRoute,
} as any);
const PerformanceKpisRoute = PerformanceKpisRouteImport.update({
  id: "/kpis",
  path: "/kpis",
  getParentRoute: () => PerformanceRouteRoute,
} as any);
const PerformanceCalendarCapacitiesRoute =
  PerformanceCalendarCapacitiesRouteImport.update({
    id: "/calendar-capacities",
    path: "/calendar-capacities",
    getParentRoute: () => PerformanceRouteRoute,
  } as any);
const CustomPageSlugRoute = CustomPageSlugRouteImport.update({
  id: "/custom-page/$slug",
  path: "/custom-page/$slug",
  getParentRoute: () => rootRouteImport,
} as any);
const BlogIdRoute = BlogIdRouteImport.update({
  id: "/$id",
  path: "/$id",
  getParentRoute: () => BlogRouteRoute,
} as any);
const AiDimensionsRoute = AiDimensionsRouteImport.update({
  id: "/dimensions",
  path: "/dimensions",
  getParentRoute: () => AiRouteRoute,
} as any);
const AiDimensionDefinitionsRoute = AiDimensionDefinitionsRouteImport.update({
  id: "/dimension-definitions",
  path: "/dimension-definitions",
  getParentRoute: () => AiRouteRoute,
} as any);
const PerformanceSettingPriorityReportRouteRoute =
  PerformanceSettingPriorityReportRouteRouteImport.update({
    id: "/setting-priority-report",
    path: "/setting-priority-report",
    getParentRoute: () => PerformanceRouteRoute,
  } as any);
const PerformanceQualityWatchRouteRoute =
  PerformanceQualityWatchRouteRouteImport.update({
    id: "/quality-watch",
    path: "/quality-watch",
    getParentRoute: () => PerformanceRouteRoute,
  } as any);
const PerformanceCallVolumeRouteRoute =
  PerformanceCallVolumeRouteRouteImport.update({
    id: "/call-volume",
    path: "/call-volume",
    getParentRoute: () => PerformanceRouteRoute,
  } as any);
const ManagementSchedulesRouteRoute =
  ManagementSchedulesRouteRouteImport.update({
    id: "/schedules",
    path: "/schedules",
    getParentRoute: () => ManagementRouteRoute,
  } as any);
const EventsIdRouteRoute = EventsIdRouteRouteImport.update({
  id: "/$id",
  path: "/$id",
  getParentRoute: () => EventsRouteRoute,
} as any);
const TestingKpisReportIndexRoute = TestingKpisReportIndexRouteImport.update({
  id: "/kpis-report/",
  path: "/kpis-report/",
  getParentRoute: () => TestingRouteRoute,
} as any);
const TestingIncidentAnalyticsIndexRoute =
  TestingIncidentAnalyticsIndexRouteImport.update({
    id: "/incident-analytics/",
    path: "/incident-analytics/",
    getParentRoute: () => TestingRouteRoute,
  } as any);
const PerformanceSettingPriorityReportIndexRoute =
  PerformanceSettingPriorityReportIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => PerformanceSettingPriorityReportRouteRoute,
  } as any);
const PerformanceReachabilityAnalysisIndexRoute =
  PerformanceReachabilityAnalysisIndexRouteImport.update({
    id: "/reachability-analysis/",
    path: "/reachability-analysis/",
    getParentRoute: () => PerformanceRouteRoute,
  } as any);
const PerformanceQualityWatchIndexRoute =
  PerformanceQualityWatchIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => PerformanceQualityWatchRouteRoute,
  } as any);
const PerformanceCallVolumeIndexRoute =
  PerformanceCallVolumeIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => PerformanceCallVolumeRouteRoute,
  } as any);
const PerformanceCallExportsIndexRoute =
  PerformanceCallExportsIndexRouteImport.update({
    id: "/call-exports/",
    path: "/call-exports/",
    getParentRoute: () => PerformanceRouteRoute,
  } as any);
const PerformanceAppointmentAnalyticsIndexRoute =
  PerformanceAppointmentAnalyticsIndexRouteImport.update({
    id: "/appointment-analytics/",
    path: "/appointment-analytics/",
    getParentRoute: () => PerformanceRouteRoute,
  } as any);
const PerformanceAgentQualityMatrixIndexRoute =
  PerformanceAgentQualityMatrixIndexRouteImport.update({
    id: "/agent-quality-matrix/",
    path: "/agent-quality-matrix/",
    getParentRoute: () => PerformanceRouteRoute,
  } as any);
const ManagementUsersIndexRoute = ManagementUsersIndexRouteImport.update({
  id: "/users/",
  path: "/users/",
  getParentRoute: () => ManagementRouteRoute,
} as any);
const ManagementTeamsIndexRoute = ManagementTeamsIndexRouteImport.update({
  id: "/teams/",
  path: "/teams/",
  getParentRoute: () => ManagementRouteRoute,
} as any);
const ManagementSchedulesIndexRoute =
  ManagementSchedulesIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => ManagementSchedulesRouteRoute,
  } as any);
const ManagementPhoneNumbersIndexRoute =
  ManagementPhoneNumbersIndexRouteImport.update({
    id: "/phone-numbers/",
    path: "/phone-numbers/",
    getParentRoute: () => ManagementRouteRoute,
  } as any);
const ManagementCustomPagesIndexRoute =
  ManagementCustomPagesIndexRouteImport.update({
    id: "/custom-pages/",
    path: "/custom-pages/",
    getParentRoute: () => ManagementRouteRoute,
  } as any);
const CallsCallIdIndexRoute = CallsCallIdIndexRouteImport.update({
  id: "/$callId/",
  path: "/$callId/",
  getParentRoute: () => CallsRouteRoute,
} as any);
const CalendarsIdIndexRoute = CalendarsIdIndexRouteImport.update({
  id: "/$id/",
  path: "/$id/",
  getParentRoute: () => CalendarsRouteRoute,
} as any);
const CalendarAppointmentsIndexRoute =
  CalendarAppointmentsIndexRouteImport.update({
    id: "/appointments/",
    path: "/appointments/",
    getParentRoute: () => CalendarRouteRoute,
  } as any);
const SettingsIntegrationsSlackRedirectRoute =
  SettingsIntegrationsSlackRedirectRouteImport.update({
    id: "/integrations/slack-redirect",
    path: "/integrations/slack-redirect",
    getParentRoute: () => SettingsRouteRoute,
  } as any);
const RecordDetailsRecordIdModuleTypeRoute =
  RecordDetailsRecordIdModuleTypeRouteImport.update({
    id: "/$recordId/$moduleType",
    path: "/$recordId/$moduleType",
    getParentRoute: () => RecordDetailsRouteRoute,
  } as any);
const EventsIdSlotsRouteRoute = EventsIdSlotsRouteRouteImport.update({
  id: "/slots",
  path: "/slots",
  getParentRoute: () => EventsIdRouteRoute,
} as any);
const EventsIdRulesRouteRoute = EventsIdRulesRouteRouteImport.update({
  id: "/rules",
  path: "/rules",
  getParentRoute: () => EventsIdRouteRoute,
} as any);
const EventsIdBookingsRouteRoute = EventsIdBookingsRouteRouteImport.update({
  id: "/bookings",
  path: "/bookings",
  getParentRoute: () => EventsIdRouteRoute,
} as any);
const ManagementSchedulesManageIndexRoute =
  ManagementSchedulesManageIndexRouteImport.update({
    id: "/manage/",
    path: "/manage/",
    getParentRoute: () => ManagementSchedulesRouteRoute,
  } as any);
const EventsIdSlotsIndexRoute = EventsIdSlotsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => EventsIdSlotsRouteRoute,
} as any);
const EventsIdRulesIndexRoute = EventsIdRulesIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => EventsIdRulesRouteRoute,
} as any);
const EventsIdBookingsIndexRoute = EventsIdBookingsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => EventsIdBookingsRouteRoute,
} as any);
const EventsIdRulesPlanIdRoute = EventsIdRulesPlanIdRouteImport.update({
  id: "/$planId",
  path: "/$planId",
  getParentRoute: () => EventsIdRulesRouteRoute,
} as any);
const PerformanceSettingPriorityReportSettingPriorityLeadsLanguagePriorityRoute =
  PerformanceSettingPriorityReportSettingPriorityLeadsLanguagePriorityRouteImport.update(
    {
      id: "/setting-priority-leads/$language/$priority",
      path: "/setting-priority-leads/$language/$priority",
      getParentRoute: () => PerformanceSettingPriorityReportRouteRoute,
    } as any,
  );

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute;
  "/ai": typeof AiRouteRouteWithChildren;
  "/blog": typeof BlogRouteRouteWithChildren;
  "/calendar": typeof CalendarRouteRouteWithChildren;
  "/calendars": typeof CalendarsRouteRouteWithChildren;
  "/calls": typeof CallsRouteRouteWithChildren;
  "/events": typeof EventsRouteRouteWithChildren;
  "/incidents": typeof IncidentsRouteRouteWithChildren;
  "/lists": typeof ListsRouteRouteWithChildren;
  "/management": typeof ManagementRouteRouteWithChildren;
  "/performance": typeof PerformanceRouteRouteWithChildren;
  "/profile": typeof ProfileRouteRouteWithChildren;
  "/prp-script": typeof PrpScriptRouteRouteWithChildren;
  "/record-details": typeof RecordDetailsRouteRouteWithChildren;
  "/settings": typeof SettingsRouteRouteWithChildren;
  "/testing": typeof TestingRouteRouteWithChildren;
  "/events/$id": typeof EventsIdRouteRouteWithChildren;
  "/management/schedules": typeof ManagementSchedulesRouteRouteWithChildren;
  "/performance/call-volume": typeof PerformanceCallVolumeRouteRouteWithChildren;
  "/performance/quality-watch": typeof PerformanceQualityWatchRouteRouteWithChildren;
  "/performance/setting-priority-report": typeof PerformanceSettingPriorityReportRouteRouteWithChildren;
  "/ai/dimension-definitions": typeof AiDimensionDefinitionsRoute;
  "/ai/dimensions": typeof AiDimensionsRoute;
  "/blog/$id": typeof BlogIdRoute;
  "/custom-page/$slug": typeof CustomPageSlugRoute;
  "/performance/calendar-capacities": typeof PerformanceCalendarCapacitiesRoute;
  "/performance/kpis": typeof PerformanceKpisRoute;
  "/performance/reports": typeof PerformanceReportsRoute;
  "/appointments/": typeof AppointmentsIndexRoute;
  "/calendars/": typeof CalendarsIndexRoute;
  "/calls/": typeof CallsIndexRoute;
  "/events/": typeof EventsIndexRoute;
  "/help-center/": typeof HelpCenterIndexRoute;
  "/hotel-capacity/": typeof HotelCapacityIndexRoute;
  "/incidents/": typeof IncidentsIndexRoute;
  "/lists/": typeof ListsIndexRoute;
  "/profile/": typeof ProfileIndexRoute;
  "/prp-script/": typeof PrpScriptIndexRoute;
  "/settings/": typeof SettingsIndexRoute;
  "/testing/": typeof TestingIndexRoute;
  "/events/$id/bookings": typeof EventsIdBookingsRouteRouteWithChildren;
  "/events/$id/rules": typeof EventsIdRulesRouteRouteWithChildren;
  "/events/$id/slots": typeof EventsIdSlotsRouteRouteWithChildren;
  "/record-details/$recordId/$moduleType": typeof RecordDetailsRecordIdModuleTypeRoute;
  "/settings/integrations/slack-redirect": typeof SettingsIntegrationsSlackRedirectRoute;
  "/calendar/appointments/": typeof CalendarAppointmentsIndexRoute;
  "/calendars/$id/": typeof CalendarsIdIndexRoute;
  "/calls/$callId/": typeof CallsCallIdIndexRoute;
  "/management/custom-pages/": typeof ManagementCustomPagesIndexRoute;
  "/management/phone-numbers/": typeof ManagementPhoneNumbersIndexRoute;
  "/management/schedules/": typeof ManagementSchedulesIndexRoute;
  "/management/teams/": typeof ManagementTeamsIndexRoute;
  "/management/users/": typeof ManagementUsersIndexRoute;
  "/performance/agent-quality-matrix/": typeof PerformanceAgentQualityMatrixIndexRoute;
  "/performance/appointment-analytics/": typeof PerformanceAppointmentAnalyticsIndexRoute;
  "/performance/call-exports/": typeof PerformanceCallExportsIndexRoute;
  "/performance/call-volume/": typeof PerformanceCallVolumeIndexRoute;
  "/performance/quality-watch/": typeof PerformanceQualityWatchIndexRoute;
  "/performance/reachability-analysis/": typeof PerformanceReachabilityAnalysisIndexRoute;
  "/performance/setting-priority-report/": typeof PerformanceSettingPriorityReportIndexRoute;
  "/testing/incident-analytics/": typeof TestingIncidentAnalyticsIndexRoute;
  "/testing/kpis-report/": typeof TestingKpisReportIndexRoute;
  "/events/$id/rules/$planId": typeof EventsIdRulesPlanIdRoute;
  "/events/$id/bookings/": typeof EventsIdBookingsIndexRoute;
  "/events/$id/rules/": typeof EventsIdRulesIndexRoute;
  "/events/$id/slots/": typeof EventsIdSlotsIndexRoute;
  "/management/schedules/manage/": typeof ManagementSchedulesManageIndexRoute;
  "/performance/setting-priority-report/setting-priority-leads/$language/$priority": typeof PerformanceSettingPriorityReportSettingPriorityLeadsLanguagePriorityRoute;
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute;
  "/ai": typeof AiRouteRouteWithChildren;
  "/blog": typeof BlogRouteRouteWithChildren;
  "/calendar": typeof CalendarRouteRouteWithChildren;
  "/management": typeof ManagementRouteRouteWithChildren;
  "/performance": typeof PerformanceRouteRouteWithChildren;
  "/record-details": typeof RecordDetailsRouteRouteWithChildren;
  "/events/$id": typeof EventsIdRouteRouteWithChildren;
  "/ai/dimension-definitions": typeof AiDimensionDefinitionsRoute;
  "/ai/dimensions": typeof AiDimensionsRoute;
  "/blog/$id": typeof BlogIdRoute;
  "/custom-page/$slug": typeof CustomPageSlugRoute;
  "/performance/calendar-capacities": typeof PerformanceCalendarCapacitiesRoute;
  "/performance/kpis": typeof PerformanceKpisRoute;
  "/performance/reports": typeof PerformanceReportsRoute;
  "/appointments": typeof AppointmentsIndexRoute;
  "/calendars": typeof CalendarsIndexRoute;
  "/calls": typeof CallsIndexRoute;
  "/events": typeof EventsIndexRoute;
  "/help-center": typeof HelpCenterIndexRoute;
  "/hotel-capacity": typeof HotelCapacityIndexRoute;
  "/incidents": typeof IncidentsIndexRoute;
  "/lists": typeof ListsIndexRoute;
  "/profile": typeof ProfileIndexRoute;
  "/prp-script": typeof PrpScriptIndexRoute;
  "/settings": typeof SettingsIndexRoute;
  "/testing": typeof TestingIndexRoute;
  "/record-details/$recordId/$moduleType": typeof RecordDetailsRecordIdModuleTypeRoute;
  "/settings/integrations/slack-redirect": typeof SettingsIntegrationsSlackRedirectRoute;
  "/calendar/appointments": typeof CalendarAppointmentsIndexRoute;
  "/calendars/$id": typeof CalendarsIdIndexRoute;
  "/calls/$callId": typeof CallsCallIdIndexRoute;
  "/management/custom-pages": typeof ManagementCustomPagesIndexRoute;
  "/management/phone-numbers": typeof ManagementPhoneNumbersIndexRoute;
  "/management/schedules": typeof ManagementSchedulesIndexRoute;
  "/management/teams": typeof ManagementTeamsIndexRoute;
  "/management/users": typeof ManagementUsersIndexRoute;
  "/performance/agent-quality-matrix": typeof PerformanceAgentQualityMatrixIndexRoute;
  "/performance/appointment-analytics": typeof PerformanceAppointmentAnalyticsIndexRoute;
  "/performance/call-exports": typeof PerformanceCallExportsIndexRoute;
  "/performance/call-volume": typeof PerformanceCallVolumeIndexRoute;
  "/performance/quality-watch": typeof PerformanceQualityWatchIndexRoute;
  "/performance/reachability-analysis": typeof PerformanceReachabilityAnalysisIndexRoute;
  "/performance/setting-priority-report": typeof PerformanceSettingPriorityReportIndexRoute;
  "/testing/incident-analytics": typeof TestingIncidentAnalyticsIndexRoute;
  "/testing/kpis-report": typeof TestingKpisReportIndexRoute;
  "/events/$id/rules/$planId": typeof EventsIdRulesPlanIdRoute;
  "/events/$id/bookings": typeof EventsIdBookingsIndexRoute;
  "/events/$id/rules": typeof EventsIdRulesIndexRoute;
  "/events/$id/slots": typeof EventsIdSlotsIndexRoute;
  "/management/schedules/manage": typeof ManagementSchedulesManageIndexRoute;
  "/performance/setting-priority-report/setting-priority-leads/$language/$priority": typeof PerformanceSettingPriorityReportSettingPriorityLeadsLanguagePriorityRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  "/": typeof IndexRoute;
  "/ai": typeof AiRouteRouteWithChildren;
  "/blog": typeof BlogRouteRouteWithChildren;
  "/calendar": typeof CalendarRouteRouteWithChildren;
  "/calendars": typeof CalendarsRouteRouteWithChildren;
  "/calls": typeof CallsRouteRouteWithChildren;
  "/events": typeof EventsRouteRouteWithChildren;
  "/incidents": typeof IncidentsRouteRouteWithChildren;
  "/lists": typeof ListsRouteRouteWithChildren;
  "/management": typeof ManagementRouteRouteWithChildren;
  "/performance": typeof PerformanceRouteRouteWithChildren;
  "/profile": typeof ProfileRouteRouteWithChildren;
  "/prp-script": typeof PrpScriptRouteRouteWithChildren;
  "/record-details": typeof RecordDetailsRouteRouteWithChildren;
  "/settings": typeof SettingsRouteRouteWithChildren;
  "/testing": typeof TestingRouteRouteWithChildren;
  "/events/$id": typeof EventsIdRouteRouteWithChildren;
  "/management/schedules": typeof ManagementSchedulesRouteRouteWithChildren;
  "/performance/call-volume": typeof PerformanceCallVolumeRouteRouteWithChildren;
  "/performance/quality-watch": typeof PerformanceQualityWatchRouteRouteWithChildren;
  "/performance/setting-priority-report": typeof PerformanceSettingPriorityReportRouteRouteWithChildren;
  "/ai/dimension-definitions": typeof AiDimensionDefinitionsRoute;
  "/ai/dimensions": typeof AiDimensionsRoute;
  "/blog/$id": typeof BlogIdRoute;
  "/custom-page/$slug": typeof CustomPageSlugRoute;
  "/performance/calendar-capacities": typeof PerformanceCalendarCapacitiesRoute;
  "/performance/kpis": typeof PerformanceKpisRoute;
  "/performance/reports": typeof PerformanceReportsRoute;
  "/appointments/": typeof AppointmentsIndexRoute;
  "/calendars/": typeof CalendarsIndexRoute;
  "/calls/": typeof CallsIndexRoute;
  "/events/": typeof EventsIndexRoute;
  "/help-center/": typeof HelpCenterIndexRoute;
  "/hotel-capacity/": typeof HotelCapacityIndexRoute;
  "/incidents/": typeof IncidentsIndexRoute;
  "/lists/": typeof ListsIndexRoute;
  "/profile/": typeof ProfileIndexRoute;
  "/prp-script/": typeof PrpScriptIndexRoute;
  "/settings/": typeof SettingsIndexRoute;
  "/testing/": typeof TestingIndexRoute;
  "/events/$id/bookings": typeof EventsIdBookingsRouteRouteWithChildren;
  "/events/$id/rules": typeof EventsIdRulesRouteRouteWithChildren;
  "/events/$id/slots": typeof EventsIdSlotsRouteRouteWithChildren;
  "/record-details/$recordId/$moduleType": typeof RecordDetailsRecordIdModuleTypeRoute;
  "/settings/integrations/slack-redirect": typeof SettingsIntegrationsSlackRedirectRoute;
  "/calendar/appointments/": typeof CalendarAppointmentsIndexRoute;
  "/calendars/$id/": typeof CalendarsIdIndexRoute;
  "/calls/$callId/": typeof CallsCallIdIndexRoute;
  "/management/custom-pages/": typeof ManagementCustomPagesIndexRoute;
  "/management/phone-numbers/": typeof ManagementPhoneNumbersIndexRoute;
  "/management/schedules/": typeof ManagementSchedulesIndexRoute;
  "/management/teams/": typeof ManagementTeamsIndexRoute;
  "/management/users/": typeof ManagementUsersIndexRoute;
  "/performance/agent-quality-matrix/": typeof PerformanceAgentQualityMatrixIndexRoute;
  "/performance/appointment-analytics/": typeof PerformanceAppointmentAnalyticsIndexRoute;
  "/performance/call-exports/": typeof PerformanceCallExportsIndexRoute;
  "/performance/call-volume/": typeof PerformanceCallVolumeIndexRoute;
  "/performance/quality-watch/": typeof PerformanceQualityWatchIndexRoute;
  "/performance/reachability-analysis/": typeof PerformanceReachabilityAnalysisIndexRoute;
  "/performance/setting-priority-report/": typeof PerformanceSettingPriorityReportIndexRoute;
  "/testing/incident-analytics/": typeof TestingIncidentAnalyticsIndexRoute;
  "/testing/kpis-report/": typeof TestingKpisReportIndexRoute;
  "/events/$id/rules/$planId": typeof EventsIdRulesPlanIdRoute;
  "/events/$id/bookings/": typeof EventsIdBookingsIndexRoute;
  "/events/$id/rules/": typeof EventsIdRulesIndexRoute;
  "/events/$id/slots/": typeof EventsIdSlotsIndexRoute;
  "/management/schedules/manage/": typeof ManagementSchedulesManageIndexRoute;
  "/performance/setting-priority-report/setting-priority-leads/$language/$priority": typeof PerformanceSettingPriorityReportSettingPriorityLeadsLanguagePriorityRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | "/"
    | "/ai"
    | "/blog"
    | "/calendar"
    | "/calendars"
    | "/calls"
    | "/events"
    | "/incidents"
    | "/lists"
    | "/management"
    | "/performance"
    | "/profile"
    | "/prp-script"
    | "/record-details"
    | "/settings"
    | "/testing"
    | "/events/$id"
    | "/management/schedules"
    | "/performance/call-volume"
    | "/performance/quality-watch"
    | "/performance/setting-priority-report"
    | "/ai/dimension-definitions"
    | "/ai/dimensions"
    | "/blog/$id"
    | "/custom-page/$slug"
    | "/performance/calendar-capacities"
    | "/performance/kpis"
    | "/performance/reports"
    | "/appointments/"
    | "/calendars/"
    | "/calls/"
    | "/events/"
    | "/help-center/"
    | "/hotel-capacity/"
    | "/incidents/"
    | "/lists/"
    | "/profile/"
    | "/prp-script/"
    | "/settings/"
    | "/testing/"
    | "/events/$id/bookings"
    | "/events/$id/rules"
    | "/events/$id/slots"
    | "/record-details/$recordId/$moduleType"
    | "/settings/integrations/slack-redirect"
    | "/calendar/appointments/"
    | "/calendars/$id/"
    | "/calls/$callId/"
    | "/management/custom-pages/"
    | "/management/phone-numbers/"
    | "/management/schedules/"
    | "/management/teams/"
    | "/management/users/"
    | "/performance/agent-quality-matrix/"
    | "/performance/appointment-analytics/"
    | "/performance/call-exports/"
    | "/performance/call-volume/"
    | "/performance/quality-watch/"
    | "/performance/reachability-analysis/"
    | "/performance/setting-priority-report/"
    | "/testing/incident-analytics/"
    | "/testing/kpis-report/"
    | "/events/$id/rules/$planId"
    | "/events/$id/bookings/"
    | "/events/$id/rules/"
    | "/events/$id/slots/"
    | "/management/schedules/manage/"
    | "/performance/setting-priority-report/setting-priority-leads/$language/$priority";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/"
    | "/ai"
    | "/blog"
    | "/calendar"
    | "/management"
    | "/performance"
    | "/record-details"
    | "/events/$id"
    | "/ai/dimension-definitions"
    | "/ai/dimensions"
    | "/blog/$id"
    | "/custom-page/$slug"
    | "/performance/calendar-capacities"
    | "/performance/kpis"
    | "/performance/reports"
    | "/appointments"
    | "/calendars"
    | "/calls"
    | "/events"
    | "/help-center"
    | "/hotel-capacity"
    | "/incidents"
    | "/lists"
    | "/profile"
    | "/prp-script"
    | "/settings"
    | "/testing"
    | "/record-details/$recordId/$moduleType"
    | "/settings/integrations/slack-redirect"
    | "/calendar/appointments"
    | "/calendars/$id"
    | "/calls/$callId"
    | "/management/custom-pages"
    | "/management/phone-numbers"
    | "/management/schedules"
    | "/management/teams"
    | "/management/users"
    | "/performance/agent-quality-matrix"
    | "/performance/appointment-analytics"
    | "/performance/call-exports"
    | "/performance/call-volume"
    | "/performance/quality-watch"
    | "/performance/reachability-analysis"
    | "/performance/setting-priority-report"
    | "/testing/incident-analytics"
    | "/testing/kpis-report"
    | "/events/$id/rules/$planId"
    | "/events/$id/bookings"
    | "/events/$id/rules"
    | "/events/$id/slots"
    | "/management/schedules/manage"
    | "/performance/setting-priority-report/setting-priority-leads/$language/$priority";
  id:
    | "__root__"
    | "/"
    | "/ai"
    | "/blog"
    | "/calendar"
    | "/calendars"
    | "/calls"
    | "/events"
    | "/incidents"
    | "/lists"
    | "/management"
    | "/performance"
    | "/profile"
    | "/prp-script"
    | "/record-details"
    | "/settings"
    | "/testing"
    | "/events/$id"
    | "/management/schedules"
    | "/performance/call-volume"
    | "/performance/quality-watch"
    | "/performance/setting-priority-report"
    | "/ai/dimension-definitions"
    | "/ai/dimensions"
    | "/blog/$id"
    | "/custom-page/$slug"
    | "/performance/calendar-capacities"
    | "/performance/kpis"
    | "/performance/reports"
    | "/appointments/"
    | "/calendars/"
    | "/calls/"
    | "/events/"
    | "/help-center/"
    | "/hotel-capacity/"
    | "/incidents/"
    | "/lists/"
    | "/profile/"
    | "/prp-script/"
    | "/settings/"
    | "/testing/"
    | "/events/$id/bookings"
    | "/events/$id/rules"
    | "/events/$id/slots"
    | "/record-details/$recordId/$moduleType"
    | "/settings/integrations/slack-redirect"
    | "/calendar/appointments/"
    | "/calendars/$id/"
    | "/calls/$callId/"
    | "/management/custom-pages/"
    | "/management/phone-numbers/"
    | "/management/schedules/"
    | "/management/teams/"
    | "/management/users/"
    | "/performance/agent-quality-matrix/"
    | "/performance/appointment-analytics/"
    | "/performance/call-exports/"
    | "/performance/call-volume/"
    | "/performance/quality-watch/"
    | "/performance/reachability-analysis/"
    | "/performance/setting-priority-report/"
    | "/testing/incident-analytics/"
    | "/testing/kpis-report/"
    | "/events/$id/rules/$planId"
    | "/events/$id/bookings/"
    | "/events/$id/rules/"
    | "/events/$id/slots/"
    | "/management/schedules/manage/"
    | "/performance/setting-priority-report/setting-priority-leads/$language/$priority";
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  AiRouteRoute: typeof AiRouteRouteWithChildren;
  BlogRouteRoute: typeof BlogRouteRouteWithChildren;
  CalendarRouteRoute: typeof CalendarRouteRouteWithChildren;
  CalendarsRouteRoute: typeof CalendarsRouteRouteWithChildren;
  CallsRouteRoute: typeof CallsRouteRouteWithChildren;
  EventsRouteRoute: typeof EventsRouteRouteWithChildren;
  IncidentsRouteRoute: typeof IncidentsRouteRouteWithChildren;
  ListsRouteRoute: typeof ListsRouteRouteWithChildren;
  ManagementRouteRoute: typeof ManagementRouteRouteWithChildren;
  PerformanceRouteRoute: typeof PerformanceRouteRouteWithChildren;
  ProfileRouteRoute: typeof ProfileRouteRouteWithChildren;
  PrpScriptRouteRoute: typeof PrpScriptRouteRouteWithChildren;
  RecordDetailsRouteRoute: typeof RecordDetailsRouteRouteWithChildren;
  SettingsRouteRoute: typeof SettingsRouteRouteWithChildren;
  TestingRouteRoute: typeof TestingRouteRouteWithChildren;
  CustomPageSlugRoute: typeof CustomPageSlugRoute;
  AppointmentsIndexRoute: typeof AppointmentsIndexRoute;
  HelpCenterIndexRoute: typeof HelpCenterIndexRoute;
  HotelCapacityIndexRoute: typeof HotelCapacityIndexRoute;
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/testing": {
      id: "/testing";
      path: "/testing";
      fullPath: "/testing";
      preLoaderRoute: typeof TestingRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings": {
      id: "/settings";
      path: "/settings";
      fullPath: "/settings";
      preLoaderRoute: typeof SettingsRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/record-details": {
      id: "/record-details";
      path: "/record-details";
      fullPath: "/record-details";
      preLoaderRoute: typeof RecordDetailsRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/prp-script": {
      id: "/prp-script";
      path: "/prp-script";
      fullPath: "/prp-script";
      preLoaderRoute: typeof PrpScriptRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/profile": {
      id: "/profile";
      path: "/profile";
      fullPath: "/profile";
      preLoaderRoute: typeof ProfileRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/performance": {
      id: "/performance";
      path: "/performance";
      fullPath: "/performance";
      preLoaderRoute: typeof PerformanceRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/management": {
      id: "/management";
      path: "/management";
      fullPath: "/management";
      preLoaderRoute: typeof ManagementRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/lists": {
      id: "/lists";
      path: "/lists";
      fullPath: "/lists";
      preLoaderRoute: typeof ListsRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/incidents": {
      id: "/incidents";
      path: "/incidents";
      fullPath: "/incidents";
      preLoaderRoute: typeof IncidentsRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/events": {
      id: "/events";
      path: "/events";
      fullPath: "/events";
      preLoaderRoute: typeof EventsRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/calls": {
      id: "/calls";
      path: "/calls";
      fullPath: "/calls";
      preLoaderRoute: typeof CallsRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/calendars": {
      id: "/calendars";
      path: "/calendars";
      fullPath: "/calendars";
      preLoaderRoute: typeof CalendarsRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/calendar": {
      id: "/calendar";
      path: "/calendar";
      fullPath: "/calendar";
      preLoaderRoute: typeof CalendarRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/blog": {
      id: "/blog";
      path: "/blog";
      fullPath: "/blog";
      preLoaderRoute: typeof BlogRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/ai": {
      id: "/ai";
      path: "/ai";
      fullPath: "/ai";
      preLoaderRoute: typeof AiRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/": {
      id: "/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/testing/": {
      id: "/testing/";
      path: "/";
      fullPath: "/testing/";
      preLoaderRoute: typeof TestingIndexRouteImport;
      parentRoute: typeof TestingRouteRoute;
    };
    "/settings/": {
      id: "/settings/";
      path: "/";
      fullPath: "/settings/";
      preLoaderRoute: typeof SettingsIndexRouteImport;
      parentRoute: typeof SettingsRouteRoute;
    };
    "/prp-script/": {
      id: "/prp-script/";
      path: "/";
      fullPath: "/prp-script/";
      preLoaderRoute: typeof PrpScriptIndexRouteImport;
      parentRoute: typeof PrpScriptRouteRoute;
    };
    "/profile/": {
      id: "/profile/";
      path: "/";
      fullPath: "/profile/";
      preLoaderRoute: typeof ProfileIndexRouteImport;
      parentRoute: typeof ProfileRouteRoute;
    };
    "/lists/": {
      id: "/lists/";
      path: "/";
      fullPath: "/lists/";
      preLoaderRoute: typeof ListsIndexRouteImport;
      parentRoute: typeof ListsRouteRoute;
    };
    "/incidents/": {
      id: "/incidents/";
      path: "/";
      fullPath: "/incidents/";
      preLoaderRoute: typeof IncidentsIndexRouteImport;
      parentRoute: typeof IncidentsRouteRoute;
    };
    "/hotel-capacity/": {
      id: "/hotel-capacity/";
      path: "/hotel-capacity";
      fullPath: "/hotel-capacity/";
      preLoaderRoute: typeof HotelCapacityIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/help-center/": {
      id: "/help-center/";
      path: "/help-center";
      fullPath: "/help-center/";
      preLoaderRoute: typeof HelpCenterIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/events/": {
      id: "/events/";
      path: "/";
      fullPath: "/events/";
      preLoaderRoute: typeof EventsIndexRouteImport;
      parentRoute: typeof EventsRouteRoute;
    };
    "/calls/": {
      id: "/calls/";
      path: "/";
      fullPath: "/calls/";
      preLoaderRoute: typeof CallsIndexRouteImport;
      parentRoute: typeof CallsRouteRoute;
    };
    "/calendars/": {
      id: "/calendars/";
      path: "/";
      fullPath: "/calendars/";
      preLoaderRoute: typeof CalendarsIndexRouteImport;
      parentRoute: typeof CalendarsRouteRoute;
    };
    "/appointments/": {
      id: "/appointments/";
      path: "/appointments";
      fullPath: "/appointments/";
      preLoaderRoute: typeof AppointmentsIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/performance/reports": {
      id: "/performance/reports";
      path: "/reports";
      fullPath: "/performance/reports";
      preLoaderRoute: typeof PerformanceReportsRouteImport;
      parentRoute: typeof PerformanceRouteRoute;
    };
    "/performance/kpis": {
      id: "/performance/kpis";
      path: "/kpis";
      fullPath: "/performance/kpis";
      preLoaderRoute: typeof PerformanceKpisRouteImport;
      parentRoute: typeof PerformanceRouteRoute;
    };
    "/performance/calendar-capacities": {
      id: "/performance/calendar-capacities";
      path: "/calendar-capacities";
      fullPath: "/performance/calendar-capacities";
      preLoaderRoute: typeof PerformanceCalendarCapacitiesRouteImport;
      parentRoute: typeof PerformanceRouteRoute;
    };
    "/custom-page/$slug": {
      id: "/custom-page/$slug";
      path: "/custom-page/$slug";
      fullPath: "/custom-page/$slug";
      preLoaderRoute: typeof CustomPageSlugRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/blog/$id": {
      id: "/blog/$id";
      path: "/$id";
      fullPath: "/blog/$id";
      preLoaderRoute: typeof BlogIdRouteImport;
      parentRoute: typeof BlogRouteRoute;
    };
    "/ai/dimensions": {
      id: "/ai/dimensions";
      path: "/dimensions";
      fullPath: "/ai/dimensions";
      preLoaderRoute: typeof AiDimensionsRouteImport;
      parentRoute: typeof AiRouteRoute;
    };
    "/ai/dimension-definitions": {
      id: "/ai/dimension-definitions";
      path: "/dimension-definitions";
      fullPath: "/ai/dimension-definitions";
      preLoaderRoute: typeof AiDimensionDefinitionsRouteImport;
      parentRoute: typeof AiRouteRoute;
    };
    "/performance/setting-priority-report": {
      id: "/performance/setting-priority-report";
      path: "/setting-priority-report";
      fullPath: "/performance/setting-priority-report";
      preLoaderRoute: typeof PerformanceSettingPriorityReportRouteRouteImport;
      parentRoute: typeof PerformanceRouteRoute;
    };
    "/performance/quality-watch": {
      id: "/performance/quality-watch";
      path: "/quality-watch";
      fullPath: "/performance/quality-watch";
      preLoaderRoute: typeof PerformanceQualityWatchRouteRouteImport;
      parentRoute: typeof PerformanceRouteRoute;
    };
    "/performance/call-volume": {
      id: "/performance/call-volume";
      path: "/call-volume";
      fullPath: "/performance/call-volume";
      preLoaderRoute: typeof PerformanceCallVolumeRouteRouteImport;
      parentRoute: typeof PerformanceRouteRoute;
    };
    "/management/schedules": {
      id: "/management/schedules";
      path: "/schedules";
      fullPath: "/management/schedules";
      preLoaderRoute: typeof ManagementSchedulesRouteRouteImport;
      parentRoute: typeof ManagementRouteRoute;
    };
    "/events/$id": {
      id: "/events/$id";
      path: "/$id";
      fullPath: "/events/$id";
      preLoaderRoute: typeof EventsIdRouteRouteImport;
      parentRoute: typeof EventsRouteRoute;
    };
    "/testing/kpis-report/": {
      id: "/testing/kpis-report/";
      path: "/kpis-report";
      fullPath: "/testing/kpis-report/";
      preLoaderRoute: typeof TestingKpisReportIndexRouteImport;
      parentRoute: typeof TestingRouteRoute;
    };
    "/testing/incident-analytics/": {
      id: "/testing/incident-analytics/";
      path: "/incident-analytics";
      fullPath: "/testing/incident-analytics/";
      preLoaderRoute: typeof TestingIncidentAnalyticsIndexRouteImport;
      parentRoute: typeof TestingRouteRoute;
    };
    "/performance/setting-priority-report/": {
      id: "/performance/setting-priority-report/";
      path: "/";
      fullPath: "/performance/setting-priority-report/";
      preLoaderRoute: typeof PerformanceSettingPriorityReportIndexRouteImport;
      parentRoute: typeof PerformanceSettingPriorityReportRouteRoute;
    };
    "/performance/reachability-analysis/": {
      id: "/performance/reachability-analysis/";
      path: "/reachability-analysis";
      fullPath: "/performance/reachability-analysis/";
      preLoaderRoute: typeof PerformanceReachabilityAnalysisIndexRouteImport;
      parentRoute: typeof PerformanceRouteRoute;
    };
    "/performance/quality-watch/": {
      id: "/performance/quality-watch/";
      path: "/";
      fullPath: "/performance/quality-watch/";
      preLoaderRoute: typeof PerformanceQualityWatchIndexRouteImport;
      parentRoute: typeof PerformanceQualityWatchRouteRoute;
    };
    "/performance/call-volume/": {
      id: "/performance/call-volume/";
      path: "/";
      fullPath: "/performance/call-volume/";
      preLoaderRoute: typeof PerformanceCallVolumeIndexRouteImport;
      parentRoute: typeof PerformanceCallVolumeRouteRoute;
    };
    "/performance/call-exports/": {
      id: "/performance/call-exports/";
      path: "/call-exports";
      fullPath: "/performance/call-exports/";
      preLoaderRoute: typeof PerformanceCallExportsIndexRouteImport;
      parentRoute: typeof PerformanceRouteRoute;
    };
    "/performance/appointment-analytics/": {
      id: "/performance/appointment-analytics/";
      path: "/appointment-analytics";
      fullPath: "/performance/appointment-analytics/";
      preLoaderRoute: typeof PerformanceAppointmentAnalyticsIndexRouteImport;
      parentRoute: typeof PerformanceRouteRoute;
    };
    "/performance/agent-quality-matrix/": {
      id: "/performance/agent-quality-matrix/";
      path: "/agent-quality-matrix";
      fullPath: "/performance/agent-quality-matrix/";
      preLoaderRoute: typeof PerformanceAgentQualityMatrixIndexRouteImport;
      parentRoute: typeof PerformanceRouteRoute;
    };
    "/management/users/": {
      id: "/management/users/";
      path: "/users";
      fullPath: "/management/users/";
      preLoaderRoute: typeof ManagementUsersIndexRouteImport;
      parentRoute: typeof ManagementRouteRoute;
    };
    "/management/teams/": {
      id: "/management/teams/";
      path: "/teams";
      fullPath: "/management/teams/";
      preLoaderRoute: typeof ManagementTeamsIndexRouteImport;
      parentRoute: typeof ManagementRouteRoute;
    };
    "/management/schedules/": {
      id: "/management/schedules/";
      path: "/";
      fullPath: "/management/schedules/";
      preLoaderRoute: typeof ManagementSchedulesIndexRouteImport;
      parentRoute: typeof ManagementSchedulesRouteRoute;
    };
    "/management/phone-numbers/": {
      id: "/management/phone-numbers/";
      path: "/phone-numbers";
      fullPath: "/management/phone-numbers/";
      preLoaderRoute: typeof ManagementPhoneNumbersIndexRouteImport;
      parentRoute: typeof ManagementRouteRoute;
    };
    "/management/custom-pages/": {
      id: "/management/custom-pages/";
      path: "/custom-pages";
      fullPath: "/management/custom-pages/";
      preLoaderRoute: typeof ManagementCustomPagesIndexRouteImport;
      parentRoute: typeof ManagementRouteRoute;
    };
    "/calls/$callId/": {
      id: "/calls/$callId/";
      path: "/$callId";
      fullPath: "/calls/$callId/";
      preLoaderRoute: typeof CallsCallIdIndexRouteImport;
      parentRoute: typeof CallsRouteRoute;
    };
    "/calendars/$id/": {
      id: "/calendars/$id/";
      path: "/$id";
      fullPath: "/calendars/$id/";
      preLoaderRoute: typeof CalendarsIdIndexRouteImport;
      parentRoute: typeof CalendarsRouteRoute;
    };
    "/calendar/appointments/": {
      id: "/calendar/appointments/";
      path: "/appointments";
      fullPath: "/calendar/appointments/";
      preLoaderRoute: typeof CalendarAppointmentsIndexRouteImport;
      parentRoute: typeof CalendarRouteRoute;
    };
    "/settings/integrations/slack-redirect": {
      id: "/settings/integrations/slack-redirect";
      path: "/integrations/slack-redirect";
      fullPath: "/settings/integrations/slack-redirect";
      preLoaderRoute: typeof SettingsIntegrationsSlackRedirectRouteImport;
      parentRoute: typeof SettingsRouteRoute;
    };
    "/record-details/$recordId/$moduleType": {
      id: "/record-details/$recordId/$moduleType";
      path: "/$recordId/$moduleType";
      fullPath: "/record-details/$recordId/$moduleType";
      preLoaderRoute: typeof RecordDetailsRecordIdModuleTypeRouteImport;
      parentRoute: typeof RecordDetailsRouteRoute;
    };
    "/events/$id/slots": {
      id: "/events/$id/slots";
      path: "/slots";
      fullPath: "/events/$id/slots";
      preLoaderRoute: typeof EventsIdSlotsRouteRouteImport;
      parentRoute: typeof EventsIdRouteRoute;
    };
    "/events/$id/rules": {
      id: "/events/$id/rules";
      path: "/rules";
      fullPath: "/events/$id/rules";
      preLoaderRoute: typeof EventsIdRulesRouteRouteImport;
      parentRoute: typeof EventsIdRouteRoute;
    };
    "/events/$id/bookings": {
      id: "/events/$id/bookings";
      path: "/bookings";
      fullPath: "/events/$id/bookings";
      preLoaderRoute: typeof EventsIdBookingsRouteRouteImport;
      parentRoute: typeof EventsIdRouteRoute;
    };
    "/management/schedules/manage/": {
      id: "/management/schedules/manage/";
      path: "/manage";
      fullPath: "/management/schedules/manage/";
      preLoaderRoute: typeof ManagementSchedulesManageIndexRouteImport;
      parentRoute: typeof ManagementSchedulesRouteRoute;
    };
    "/events/$id/slots/": {
      id: "/events/$id/slots/";
      path: "/";
      fullPath: "/events/$id/slots/";
      preLoaderRoute: typeof EventsIdSlotsIndexRouteImport;
      parentRoute: typeof EventsIdSlotsRouteRoute;
    };
    "/events/$id/rules/": {
      id: "/events/$id/rules/";
      path: "/";
      fullPath: "/events/$id/rules/";
      preLoaderRoute: typeof EventsIdRulesIndexRouteImport;
      parentRoute: typeof EventsIdRulesRouteRoute;
    };
    "/events/$id/bookings/": {
      id: "/events/$id/bookings/";
      path: "/";
      fullPath: "/events/$id/bookings/";
      preLoaderRoute: typeof EventsIdBookingsIndexRouteImport;
      parentRoute: typeof EventsIdBookingsRouteRoute;
    };
    "/events/$id/rules/$planId": {
      id: "/events/$id/rules/$planId";
      path: "/$planId";
      fullPath: "/events/$id/rules/$planId";
      preLoaderRoute: typeof EventsIdRulesPlanIdRouteImport;
      parentRoute: typeof EventsIdRulesRouteRoute;
    };
    "/performance/setting-priority-report/setting-priority-leads/$language/$priority": {
      id: "/performance/setting-priority-report/setting-priority-leads/$language/$priority";
      path: "/setting-priority-leads/$language/$priority";
      fullPath: "/performance/setting-priority-report/setting-priority-leads/$language/$priority";
      preLoaderRoute: typeof PerformanceSettingPriorityReportSettingPriorityLeadsLanguagePriorityRouteImport;
      parentRoute: typeof PerformanceSettingPriorityReportRouteRoute;
    };
  }
}

interface AiRouteRouteChildren {
  AiDimensionDefinitionsRoute: typeof AiDimensionDefinitionsRoute;
  AiDimensionsRoute: typeof AiDimensionsRoute;
}

const AiRouteRouteChildren: AiRouteRouteChildren = {
  AiDimensionDefinitionsRoute: AiDimensionDefinitionsRoute,
  AiDimensionsRoute: AiDimensionsRoute,
};

const AiRouteRouteWithChildren =
  AiRouteRoute._addFileChildren(AiRouteRouteChildren);

interface BlogRouteRouteChildren {
  BlogIdRoute: typeof BlogIdRoute;
}

const BlogRouteRouteChildren: BlogRouteRouteChildren = {
  BlogIdRoute: BlogIdRoute,
};

const BlogRouteRouteWithChildren = BlogRouteRoute._addFileChildren(
  BlogRouteRouteChildren,
);

interface CalendarRouteRouteChildren {
  CalendarAppointmentsIndexRoute: typeof CalendarAppointmentsIndexRoute;
}

const CalendarRouteRouteChildren: CalendarRouteRouteChildren = {
  CalendarAppointmentsIndexRoute: CalendarAppointmentsIndexRoute,
};

const CalendarRouteRouteWithChildren = CalendarRouteRoute._addFileChildren(
  CalendarRouteRouteChildren,
);

interface CalendarsRouteRouteChildren {
  CalendarsIndexRoute: typeof CalendarsIndexRoute;
  CalendarsIdIndexRoute: typeof CalendarsIdIndexRoute;
}

const CalendarsRouteRouteChildren: CalendarsRouteRouteChildren = {
  CalendarsIndexRoute: CalendarsIndexRoute,
  CalendarsIdIndexRoute: CalendarsIdIndexRoute,
};

const CalendarsRouteRouteWithChildren = CalendarsRouteRoute._addFileChildren(
  CalendarsRouteRouteChildren,
);

interface CallsRouteRouteChildren {
  CallsIndexRoute: typeof CallsIndexRoute;
  CallsCallIdIndexRoute: typeof CallsCallIdIndexRoute;
}

const CallsRouteRouteChildren: CallsRouteRouteChildren = {
  CallsIndexRoute: CallsIndexRoute,
  CallsCallIdIndexRoute: CallsCallIdIndexRoute,
};

const CallsRouteRouteWithChildren = CallsRouteRoute._addFileChildren(
  CallsRouteRouteChildren,
);

interface EventsIdBookingsRouteRouteChildren {
  EventsIdBookingsIndexRoute: typeof EventsIdBookingsIndexRoute;
}

const EventsIdBookingsRouteRouteChildren: EventsIdBookingsRouteRouteChildren = {
  EventsIdBookingsIndexRoute: EventsIdBookingsIndexRoute,
};

const EventsIdBookingsRouteRouteWithChildren =
  EventsIdBookingsRouteRoute._addFileChildren(
    EventsIdBookingsRouteRouteChildren,
  );

interface EventsIdRulesRouteRouteChildren {
  EventsIdRulesPlanIdRoute: typeof EventsIdRulesPlanIdRoute;
  EventsIdRulesIndexRoute: typeof EventsIdRulesIndexRoute;
}

const EventsIdRulesRouteRouteChildren: EventsIdRulesRouteRouteChildren = {
  EventsIdRulesPlanIdRoute: EventsIdRulesPlanIdRoute,
  EventsIdRulesIndexRoute: EventsIdRulesIndexRoute,
};

const EventsIdRulesRouteRouteWithChildren =
  EventsIdRulesRouteRoute._addFileChildren(EventsIdRulesRouteRouteChildren);

interface EventsIdSlotsRouteRouteChildren {
  EventsIdSlotsIndexRoute: typeof EventsIdSlotsIndexRoute;
}

const EventsIdSlotsRouteRouteChildren: EventsIdSlotsRouteRouteChildren = {
  EventsIdSlotsIndexRoute: EventsIdSlotsIndexRoute,
};

const EventsIdSlotsRouteRouteWithChildren =
  EventsIdSlotsRouteRoute._addFileChildren(EventsIdSlotsRouteRouteChildren);

interface EventsIdRouteRouteChildren {
  EventsIdBookingsRouteRoute: typeof EventsIdBookingsRouteRouteWithChildren;
  EventsIdRulesRouteRoute: typeof EventsIdRulesRouteRouteWithChildren;
  EventsIdSlotsRouteRoute: typeof EventsIdSlotsRouteRouteWithChildren;
}

const EventsIdRouteRouteChildren: EventsIdRouteRouteChildren = {
  EventsIdBookingsRouteRoute: EventsIdBookingsRouteRouteWithChildren,
  EventsIdRulesRouteRoute: EventsIdRulesRouteRouteWithChildren,
  EventsIdSlotsRouteRoute: EventsIdSlotsRouteRouteWithChildren,
};

const EventsIdRouteRouteWithChildren = EventsIdRouteRoute._addFileChildren(
  EventsIdRouteRouteChildren,
);

interface EventsRouteRouteChildren {
  EventsIdRouteRoute: typeof EventsIdRouteRouteWithChildren;
  EventsIndexRoute: typeof EventsIndexRoute;
}

const EventsRouteRouteChildren: EventsRouteRouteChildren = {
  EventsIdRouteRoute: EventsIdRouteRouteWithChildren,
  EventsIndexRoute: EventsIndexRoute,
};

const EventsRouteRouteWithChildren = EventsRouteRoute._addFileChildren(
  EventsRouteRouteChildren,
);

interface IncidentsRouteRouteChildren {
  IncidentsIndexRoute: typeof IncidentsIndexRoute;
}

const IncidentsRouteRouteChildren: IncidentsRouteRouteChildren = {
  IncidentsIndexRoute: IncidentsIndexRoute,
};

const IncidentsRouteRouteWithChildren = IncidentsRouteRoute._addFileChildren(
  IncidentsRouteRouteChildren,
);

interface ListsRouteRouteChildren {
  ListsIndexRoute: typeof ListsIndexRoute;
}

const ListsRouteRouteChildren: ListsRouteRouteChildren = {
  ListsIndexRoute: ListsIndexRoute,
};

const ListsRouteRouteWithChildren = ListsRouteRoute._addFileChildren(
  ListsRouteRouteChildren,
);

interface ManagementSchedulesRouteRouteChildren {
  ManagementSchedulesIndexRoute: typeof ManagementSchedulesIndexRoute;
  ManagementSchedulesManageIndexRoute: typeof ManagementSchedulesManageIndexRoute;
}

const ManagementSchedulesRouteRouteChildren: ManagementSchedulesRouteRouteChildren =
  {
    ManagementSchedulesIndexRoute: ManagementSchedulesIndexRoute,
    ManagementSchedulesManageIndexRoute: ManagementSchedulesManageIndexRoute,
  };

const ManagementSchedulesRouteRouteWithChildren =
  ManagementSchedulesRouteRoute._addFileChildren(
    ManagementSchedulesRouteRouteChildren,
  );

interface ManagementRouteRouteChildren {
  ManagementSchedulesRouteRoute: typeof ManagementSchedulesRouteRouteWithChildren;
  ManagementCustomPagesIndexRoute: typeof ManagementCustomPagesIndexRoute;
  ManagementPhoneNumbersIndexRoute: typeof ManagementPhoneNumbersIndexRoute;
  ManagementTeamsIndexRoute: typeof ManagementTeamsIndexRoute;
  ManagementUsersIndexRoute: typeof ManagementUsersIndexRoute;
}

const ManagementRouteRouteChildren: ManagementRouteRouteChildren = {
  ManagementSchedulesRouteRoute: ManagementSchedulesRouteRouteWithChildren,
  ManagementCustomPagesIndexRoute: ManagementCustomPagesIndexRoute,
  ManagementPhoneNumbersIndexRoute: ManagementPhoneNumbersIndexRoute,
  ManagementTeamsIndexRoute: ManagementTeamsIndexRoute,
  ManagementUsersIndexRoute: ManagementUsersIndexRoute,
};

const ManagementRouteRouteWithChildren = ManagementRouteRoute._addFileChildren(
  ManagementRouteRouteChildren,
);

interface PerformanceCallVolumeRouteRouteChildren {
  PerformanceCallVolumeIndexRoute: typeof PerformanceCallVolumeIndexRoute;
}

const PerformanceCallVolumeRouteRouteChildren: PerformanceCallVolumeRouteRouteChildren =
  {
    PerformanceCallVolumeIndexRoute: PerformanceCallVolumeIndexRoute,
  };

const PerformanceCallVolumeRouteRouteWithChildren =
  PerformanceCallVolumeRouteRoute._addFileChildren(
    PerformanceCallVolumeRouteRouteChildren,
  );

interface PerformanceQualityWatchRouteRouteChildren {
  PerformanceQualityWatchIndexRoute: typeof PerformanceQualityWatchIndexRoute;
}

const PerformanceQualityWatchRouteRouteChildren: PerformanceQualityWatchRouteRouteChildren =
  {
    PerformanceQualityWatchIndexRoute: PerformanceQualityWatchIndexRoute,
  };

const PerformanceQualityWatchRouteRouteWithChildren =
  PerformanceQualityWatchRouteRoute._addFileChildren(
    PerformanceQualityWatchRouteRouteChildren,
  );

interface PerformanceSettingPriorityReportRouteRouteChildren {
  PerformanceSettingPriorityReportIndexRoute: typeof PerformanceSettingPriorityReportIndexRoute;
  PerformanceSettingPriorityReportSettingPriorityLeadsLanguagePriorityRoute: typeof PerformanceSettingPriorityReportSettingPriorityLeadsLanguagePriorityRoute;
}

const PerformanceSettingPriorityReportRouteRouteChildren: PerformanceSettingPriorityReportRouteRouteChildren =
  {
    PerformanceSettingPriorityReportIndexRoute:
      PerformanceSettingPriorityReportIndexRoute,
    PerformanceSettingPriorityReportSettingPriorityLeadsLanguagePriorityRoute:
      PerformanceSettingPriorityReportSettingPriorityLeadsLanguagePriorityRoute,
  };

const PerformanceSettingPriorityReportRouteRouteWithChildren =
  PerformanceSettingPriorityReportRouteRoute._addFileChildren(
    PerformanceSettingPriorityReportRouteRouteChildren,
  );

interface PerformanceRouteRouteChildren {
  PerformanceCallVolumeRouteRoute: typeof PerformanceCallVolumeRouteRouteWithChildren;
  PerformanceQualityWatchRouteRoute: typeof PerformanceQualityWatchRouteRouteWithChildren;
  PerformanceSettingPriorityReportRouteRoute: typeof PerformanceSettingPriorityReportRouteRouteWithChildren;
  PerformanceCalendarCapacitiesRoute: typeof PerformanceCalendarCapacitiesRoute;
  PerformanceKpisRoute: typeof PerformanceKpisRoute;
  PerformanceReportsRoute: typeof PerformanceReportsRoute;
  PerformanceAgentQualityMatrixIndexRoute: typeof PerformanceAgentQualityMatrixIndexRoute;
  PerformanceAppointmentAnalyticsIndexRoute: typeof PerformanceAppointmentAnalyticsIndexRoute;
  PerformanceCallExportsIndexRoute: typeof PerformanceCallExportsIndexRoute;
  PerformanceReachabilityAnalysisIndexRoute: typeof PerformanceReachabilityAnalysisIndexRoute;
}

const PerformanceRouteRouteChildren: PerformanceRouteRouteChildren = {
  PerformanceCallVolumeRouteRoute: PerformanceCallVolumeRouteRouteWithChildren,
  PerformanceQualityWatchRouteRoute:
    PerformanceQualityWatchRouteRouteWithChildren,
  PerformanceSettingPriorityReportRouteRoute:
    PerformanceSettingPriorityReportRouteRouteWithChildren,
  PerformanceCalendarCapacitiesRoute: PerformanceCalendarCapacitiesRoute,
  PerformanceKpisRoute: PerformanceKpisRoute,
  PerformanceReportsRoute: PerformanceReportsRoute,
  PerformanceAgentQualityMatrixIndexRoute:
    PerformanceAgentQualityMatrixIndexRoute,
  PerformanceAppointmentAnalyticsIndexRoute:
    PerformanceAppointmentAnalyticsIndexRoute,
  PerformanceCallExportsIndexRoute: PerformanceCallExportsIndexRoute,
  PerformanceReachabilityAnalysisIndexRoute:
    PerformanceReachabilityAnalysisIndexRoute,
};

const PerformanceRouteRouteWithChildren =
  PerformanceRouteRoute._addFileChildren(PerformanceRouteRouteChildren);

interface ProfileRouteRouteChildren {
  ProfileIndexRoute: typeof ProfileIndexRoute;
}

const ProfileRouteRouteChildren: ProfileRouteRouteChildren = {
  ProfileIndexRoute: ProfileIndexRoute,
};

const ProfileRouteRouteWithChildren = ProfileRouteRoute._addFileChildren(
  ProfileRouteRouteChildren,
);

interface PrpScriptRouteRouteChildren {
  PrpScriptIndexRoute: typeof PrpScriptIndexRoute;
}

const PrpScriptRouteRouteChildren: PrpScriptRouteRouteChildren = {
  PrpScriptIndexRoute: PrpScriptIndexRoute,
};

const PrpScriptRouteRouteWithChildren = PrpScriptRouteRoute._addFileChildren(
  PrpScriptRouteRouteChildren,
);

interface RecordDetailsRouteRouteChildren {
  RecordDetailsRecordIdModuleTypeRoute: typeof RecordDetailsRecordIdModuleTypeRoute;
}

const RecordDetailsRouteRouteChildren: RecordDetailsRouteRouteChildren = {
  RecordDetailsRecordIdModuleTypeRoute: RecordDetailsRecordIdModuleTypeRoute,
};

const RecordDetailsRouteRouteWithChildren =
  RecordDetailsRouteRoute._addFileChildren(RecordDetailsRouteRouteChildren);

interface SettingsRouteRouteChildren {
  SettingsIndexRoute: typeof SettingsIndexRoute;
  SettingsIntegrationsSlackRedirectRoute: typeof SettingsIntegrationsSlackRedirectRoute;
}

const SettingsRouteRouteChildren: SettingsRouteRouteChildren = {
  SettingsIndexRoute: SettingsIndexRoute,
  SettingsIntegrationsSlackRedirectRoute:
    SettingsIntegrationsSlackRedirectRoute,
};

const SettingsRouteRouteWithChildren = SettingsRouteRoute._addFileChildren(
  SettingsRouteRouteChildren,
);

interface TestingRouteRouteChildren {
  TestingIndexRoute: typeof TestingIndexRoute;
  TestingIncidentAnalyticsIndexRoute: typeof TestingIncidentAnalyticsIndexRoute;
  TestingKpisReportIndexRoute: typeof TestingKpisReportIndexRoute;
}

const TestingRouteRouteChildren: TestingRouteRouteChildren = {
  TestingIndexRoute: TestingIndexRoute,
  TestingIncidentAnalyticsIndexRoute: TestingIncidentAnalyticsIndexRoute,
  TestingKpisReportIndexRoute: TestingKpisReportIndexRoute,
};

const TestingRouteRouteWithChildren = TestingRouteRoute._addFileChildren(
  TestingRouteRouteChildren,
);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AiRouteRoute: AiRouteRouteWithChildren,
  BlogRouteRoute: BlogRouteRouteWithChildren,
  CalendarRouteRoute: CalendarRouteRouteWithChildren,
  CalendarsRouteRoute: CalendarsRouteRouteWithChildren,
  CallsRouteRoute: CallsRouteRouteWithChildren,
  EventsRouteRoute: EventsRouteRouteWithChildren,
  IncidentsRouteRoute: IncidentsRouteRouteWithChildren,
  ListsRouteRoute: ListsRouteRouteWithChildren,
  ManagementRouteRoute: ManagementRouteRouteWithChildren,
  PerformanceRouteRoute: PerformanceRouteRouteWithChildren,
  ProfileRouteRoute: ProfileRouteRouteWithChildren,
  PrpScriptRouteRoute: PrpScriptRouteRouteWithChildren,
  RecordDetailsRouteRoute: RecordDetailsRouteRouteWithChildren,
  SettingsRouteRoute: SettingsRouteRouteWithChildren,
  TestingRouteRoute: TestingRouteRouteWithChildren,
  CustomPageSlugRoute: CustomPageSlugRoute,
  AppointmentsIndexRoute: AppointmentsIndexRoute,
  HelpCenterIndexRoute: HelpCenterIndexRoute,
  HotelCapacityIndexRoute: HotelCapacityIndexRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
